import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import { forwardRef } from 'react';
import { c as classNames } from '../../shared/index-e39a0673.js';
import { getTestId } from '../../utils/testId.js';
import { getSizingClassName, getSizingStyle } from '../../utils/sizing.js';
import { getPaddingClasses } from '../../utils/padding.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "stack--p-none": "web_ui__Stack__stack--p-none",
  "stack--pt-none": "web_ui__Stack__stack--pt-none",
  "stack--pr-none": "web_ui__Stack__stack--pr-none",
  "stack--pb-none": "web_ui__Stack__stack--pb-none",
  "stack--pl-none": "web_ui__Stack__stack--pl-none",
  "stack--px-none": "web_ui__Stack__stack--px-none",
  "stack--py-none": "web_ui__Stack__stack--py-none",
  "stack--p-x-small": "web_ui__Stack__stack--p-x-small",
  "stack--pt-x-small": "web_ui__Stack__stack--pt-x-small",
  "stack--pr-x-small": "web_ui__Stack__stack--pr-x-small",
  "stack--pb-x-small": "web_ui__Stack__stack--pb-x-small",
  "stack--pl-x-small": "web_ui__Stack__stack--pl-x-small",
  "stack--px-x-small": "web_ui__Stack__stack--px-x-small",
  "stack--py-x-small": "web_ui__Stack__stack--py-x-small",
  "stack--p-small": "web_ui__Stack__stack--p-small",
  "stack--pt-small": "web_ui__Stack__stack--pt-small",
  "stack--pr-small": "web_ui__Stack__stack--pr-small",
  "stack--pb-small": "web_ui__Stack__stack--pb-small",
  "stack--pl-small": "web_ui__Stack__stack--pl-small",
  "stack--px-small": "web_ui__Stack__stack--px-small",
  "stack--py-small": "web_ui__Stack__stack--py-small",
  "stack--p-regular": "web_ui__Stack__stack--p-regular",
  "stack--pt-regular": "web_ui__Stack__stack--pt-regular",
  "stack--pr-regular": "web_ui__Stack__stack--pr-regular",
  "stack--pb-regular": "web_ui__Stack__stack--pb-regular",
  "stack--pl-regular": "web_ui__Stack__stack--pl-regular",
  "stack--px-regular": "web_ui__Stack__stack--px-regular",
  "stack--py-regular": "web_ui__Stack__stack--py-regular",
  "stack--p-medium": "web_ui__Stack__stack--p-medium",
  "stack--pt-medium": "web_ui__Stack__stack--pt-medium",
  "stack--pr-medium": "web_ui__Stack__stack--pr-medium",
  "stack--pb-medium": "web_ui__Stack__stack--pb-medium",
  "stack--pl-medium": "web_ui__Stack__stack--pl-medium",
  "stack--px-medium": "web_ui__Stack__stack--px-medium",
  "stack--py-medium": "web_ui__Stack__stack--py-medium",
  "stack--p-large": "web_ui__Stack__stack--p-large",
  "stack--pt-large": "web_ui__Stack__stack--pt-large",
  "stack--pr-large": "web_ui__Stack__stack--pr-large",
  "stack--pb-large": "web_ui__Stack__stack--pb-large",
  "stack--pl-large": "web_ui__Stack__stack--pl-large",
  "stack--px-large": "web_ui__Stack__stack--px-large",
  "stack--py-large": "web_ui__Stack__stack--py-large",
  "stack--p-larger": "web_ui__Stack__stack--p-larger",
  "stack--pt-larger": "web_ui__Stack__stack--pt-larger",
  "stack--pr-larger": "web_ui__Stack__stack--pr-larger",
  "stack--pb-larger": "web_ui__Stack__stack--pb-larger",
  "stack--pl-larger": "web_ui__Stack__stack--pl-larger",
  "stack--px-larger": "web_ui__Stack__stack--px-larger",
  "stack--py-larger": "web_ui__Stack__stack--py-larger",
  "stack--p-x-large": "web_ui__Stack__stack--p-x-large",
  "stack--pt-x-large": "web_ui__Stack__stack--pt-x-large",
  "stack--pr-x-large": "web_ui__Stack__stack--pr-x-large",
  "stack--pb-x-large": "web_ui__Stack__stack--pb-x-large",
  "stack--pl-x-large": "web_ui__Stack__stack--pl-x-large",
  "stack--px-x-large": "web_ui__Stack__stack--px-x-large",
  "stack--py-x-large": "web_ui__Stack__stack--py-x-large",
  "stack--p-x-larger": "web_ui__Stack__stack--p-x-larger",
  "stack--pt-x-larger": "web_ui__Stack__stack--pt-x-larger",
  "stack--pr-x-larger": "web_ui__Stack__stack--pr-x-larger",
  "stack--pb-x-larger": "web_ui__Stack__stack--pb-x-larger",
  "stack--pl-x-larger": "web_ui__Stack__stack--pl-x-larger",
  "stack--px-x-larger": "web_ui__Stack__stack--px-x-larger",
  "stack--py-x-larger": "web_ui__Stack__stack--py-x-larger",
  "stack--p-x2-large": "web_ui__Stack__stack--p-x2-large",
  "stack--pt-x2-large": "web_ui__Stack__stack--pt-x2-large",
  "stack--pr-x2-large": "web_ui__Stack__stack--pr-x2-large",
  "stack--pb-x2-large": "web_ui__Stack__stack--pb-x2-large",
  "stack--pl-x2-large": "web_ui__Stack__stack--pl-x2-large",
  "stack--px-x2-large": "web_ui__Stack__stack--px-x2-large",
  "stack--py-x2-large": "web_ui__Stack__stack--py-x2-large",
  "stack--p-x3-large": "web_ui__Stack__stack--p-x3-large",
  "stack--pt-x3-large": "web_ui__Stack__stack--pt-x3-large",
  "stack--pr-x3-large": "web_ui__Stack__stack--pr-x3-large",
  "stack--pb-x3-large": "web_ui__Stack__stack--pb-x3-large",
  "stack--pl-x3-large": "web_ui__Stack__stack--pl-x3-large",
  "stack--px-x3-large": "web_ui__Stack__stack--px-x3-large",
  "stack--py-x3-large": "web_ui__Stack__stack--py-x3-large",
  "stack--p-x4-large": "web_ui__Stack__stack--p-x4-large",
  "stack--pt-x4-large": "web_ui__Stack__stack--pt-x4-large",
  "stack--pr-x4-large": "web_ui__Stack__stack--pr-x4-large",
  "stack--pb-x4-large": "web_ui__Stack__stack--pb-x4-large",
  "stack--pl-x4-large": "web_ui__Stack__stack--pl-x4-large",
  "stack--px-x4-large": "web_ui__Stack__stack--px-x4-large",
  "stack--py-x4-large": "web_ui__Stack__stack--py-x4-large",
  "stack--p-x5-large": "web_ui__Stack__stack--p-x5-large",
  "stack--pt-x5-large": "web_ui__Stack__stack--pt-x5-large",
  "stack--pr-x5-large": "web_ui__Stack__stack--pr-x5-large",
  "stack--pb-x5-large": "web_ui__Stack__stack--pb-x5-large",
  "stack--pl-x5-large": "web_ui__Stack__stack--pl-x5-large",
  "stack--px-x5-large": "web_ui__Stack__stack--px-x5-large",
  "stack--py-x5-large": "web_ui__Stack__stack--py-x5-large",
  "stack--p-x6-large": "web_ui__Stack__stack--p-x6-large",
  "stack--pt-x6-large": "web_ui__Stack__stack--pt-x6-large",
  "stack--pr-x6-large": "web_ui__Stack__stack--pr-x6-large",
  "stack--pb-x6-large": "web_ui__Stack__stack--pb-x6-large",
  "stack--pl-x6-large": "web_ui__Stack__stack--pl-x6-large",
  "stack--px-x6-large": "web_ui__Stack__stack--px-x6-large",
  "stack--py-x6-large": "web_ui__Stack__stack--py-x6-large",
  "stack--p-space-0": "web_ui__Stack__stack--p-space-0",
  "stack--pt-space-0": "web_ui__Stack__stack--pt-space-0",
  "stack--pr-space-0": "web_ui__Stack__stack--pr-space-0",
  "stack--pb-space-0": "web_ui__Stack__stack--pb-space-0",
  "stack--pl-space-0": "web_ui__Stack__stack--pl-space-0",
  "stack--px-space-0": "web_ui__Stack__stack--px-space-0",
  "stack--py-space-0": "web_ui__Stack__stack--py-space-0",
  "stack--p-space-50": "web_ui__Stack__stack--p-space-50",
  "stack--pt-space-50": "web_ui__Stack__stack--pt-space-50",
  "stack--pr-space-50": "web_ui__Stack__stack--pr-space-50",
  "stack--pb-space-50": "web_ui__Stack__stack--pb-space-50",
  "stack--pl-space-50": "web_ui__Stack__stack--pl-space-50",
  "stack--px-space-50": "web_ui__Stack__stack--px-space-50",
  "stack--py-space-50": "web_ui__Stack__stack--py-space-50",
  "stack--p-space-100": "web_ui__Stack__stack--p-space-100",
  "stack--pt-space-100": "web_ui__Stack__stack--pt-space-100",
  "stack--pr-space-100": "web_ui__Stack__stack--pr-space-100",
  "stack--pb-space-100": "web_ui__Stack__stack--pb-space-100",
  "stack--pl-space-100": "web_ui__Stack__stack--pl-space-100",
  "stack--px-space-100": "web_ui__Stack__stack--px-space-100",
  "stack--py-space-100": "web_ui__Stack__stack--py-space-100",
  "stack--p-space-150": "web_ui__Stack__stack--p-space-150",
  "stack--pt-space-150": "web_ui__Stack__stack--pt-space-150",
  "stack--pr-space-150": "web_ui__Stack__stack--pr-space-150",
  "stack--pb-space-150": "web_ui__Stack__stack--pb-space-150",
  "stack--pl-space-150": "web_ui__Stack__stack--pl-space-150",
  "stack--px-space-150": "web_ui__Stack__stack--px-space-150",
  "stack--py-space-150": "web_ui__Stack__stack--py-space-150",
  "stack--p-space-200": "web_ui__Stack__stack--p-space-200",
  "stack--pt-space-200": "web_ui__Stack__stack--pt-space-200",
  "stack--pr-space-200": "web_ui__Stack__stack--pr-space-200",
  "stack--pb-space-200": "web_ui__Stack__stack--pb-space-200",
  "stack--pl-space-200": "web_ui__Stack__stack--pl-space-200",
  "stack--px-space-200": "web_ui__Stack__stack--px-space-200",
  "stack--py-space-200": "web_ui__Stack__stack--py-space-200",
  "stack--p-space-300": "web_ui__Stack__stack--p-space-300",
  "stack--pt-space-300": "web_ui__Stack__stack--pt-space-300",
  "stack--pr-space-300": "web_ui__Stack__stack--pr-space-300",
  "stack--pb-space-300": "web_ui__Stack__stack--pb-space-300",
  "stack--pl-space-300": "web_ui__Stack__stack--pl-space-300",
  "stack--px-space-300": "web_ui__Stack__stack--px-space-300",
  "stack--py-space-300": "web_ui__Stack__stack--py-space-300",
  "stack--p-space-400": "web_ui__Stack__stack--p-space-400",
  "stack--pt-space-400": "web_ui__Stack__stack--pt-space-400",
  "stack--pr-space-400": "web_ui__Stack__stack--pr-space-400",
  "stack--pb-space-400": "web_ui__Stack__stack--pb-space-400",
  "stack--pl-space-400": "web_ui__Stack__stack--pl-space-400",
  "stack--px-space-400": "web_ui__Stack__stack--px-space-400",
  "stack--py-space-400": "web_ui__Stack__stack--py-space-400",
  "stack--p-space-500": "web_ui__Stack__stack--p-space-500",
  "stack--pt-space-500": "web_ui__Stack__stack--pt-space-500",
  "stack--pr-space-500": "web_ui__Stack__stack--pr-space-500",
  "stack--pb-space-500": "web_ui__Stack__stack--pb-space-500",
  "stack--pl-space-500": "web_ui__Stack__stack--pl-space-500",
  "stack--px-space-500": "web_ui__Stack__stack--px-space-500",
  "stack--py-space-500": "web_ui__Stack__stack--py-space-500",
  "stack--p-space-600": "web_ui__Stack__stack--p-space-600",
  "stack--pt-space-600": "web_ui__Stack__stack--pt-space-600",
  "stack--pr-space-600": "web_ui__Stack__stack--pr-space-600",
  "stack--pb-space-600": "web_ui__Stack__stack--pb-space-600",
  "stack--pl-space-600": "web_ui__Stack__stack--pl-space-600",
  "stack--px-space-600": "web_ui__Stack__stack--px-space-600",
  "stack--py-space-600": "web_ui__Stack__stack--py-space-600",
  "stack--p-space-700": "web_ui__Stack__stack--p-space-700",
  "stack--pt-space-700": "web_ui__Stack__stack--pt-space-700",
  "stack--pr-space-700": "web_ui__Stack__stack--pr-space-700",
  "stack--pb-space-700": "web_ui__Stack__stack--pb-space-700",
  "stack--pl-space-700": "web_ui__Stack__stack--pl-space-700",
  "stack--px-space-700": "web_ui__Stack__stack--px-space-700",
  "stack--py-space-700": "web_ui__Stack__stack--py-space-700",
  "stack--p-space-900": "web_ui__Stack__stack--p-space-900",
  "stack--pt-space-900": "web_ui__Stack__stack--pt-space-900",
  "stack--pr-space-900": "web_ui__Stack__stack--pr-space-900",
  "stack--pb-space-900": "web_ui__Stack__stack--pb-space-900",
  "stack--pl-space-900": "web_ui__Stack__stack--pl-space-900",
  "stack--px-space-900": "web_ui__Stack__stack--px-space-900",
  "stack--py-space-900": "web_ui__Stack__stack--py-space-900",
  "stack--p-space-800": "web_ui__Stack__stack--p-space-800",
  "stack--pt-space-800": "web_ui__Stack__stack--pt-space-800",
  "stack--pr-space-800": "web_ui__Stack__stack--pr-space-800",
  "stack--pb-space-800": "web_ui__Stack__stack--pb-space-800",
  "stack--pl-space-800": "web_ui__Stack__stack--pl-space-800",
  "stack--px-space-800": "web_ui__Stack__stack--px-space-800",
  "stack--py-space-800": "web_ui__Stack__stack--py-space-800",
  "stack--p-space-1000": "web_ui__Stack__stack--p-space-1000",
  "stack--pt-space-1000": "web_ui__Stack__stack--pt-space-1000",
  "stack--pr-space-1000": "web_ui__Stack__stack--pr-space-1000",
  "stack--pb-space-1000": "web_ui__Stack__stack--pb-space-1000",
  "stack--pl-space-1000": "web_ui__Stack__stack--pl-space-1000",
  "stack--px-space-1000": "web_ui__Stack__stack--px-space-1000",
  "stack--py-space-1000": "web_ui__Stack__stack--py-space-1000",
  "stack--p-space-1100": "web_ui__Stack__stack--p-space-1100",
  "stack--pt-space-1100": "web_ui__Stack__stack--pt-space-1100",
  "stack--pr-space-1100": "web_ui__Stack__stack--pr-space-1100",
  "stack--pb-space-1100": "web_ui__Stack__stack--pb-space-1100",
  "stack--pl-space-1100": "web_ui__Stack__stack--pl-space-1100",
  "stack--px-space-1100": "web_ui__Stack__stack--px-space-1100",
  "stack--py-space-1100": "web_ui__Stack__stack--py-space-1100",
  "stack--p-space-1200": "web_ui__Stack__stack--p-space-1200",
  "stack--pt-space-1200": "web_ui__Stack__stack--pt-space-1200",
  "stack--pr-space-1200": "web_ui__Stack__stack--pr-space-1200",
  "stack--pb-space-1200": "web_ui__Stack__stack--pb-space-1200",
  "stack--pl-space-1200": "web_ui__Stack__stack--pl-space-1200",
  "stack--px-space-1200": "web_ui__Stack__stack--px-space-1200",
  "stack--py-space-1200": "web_ui__Stack__stack--py-space-1200",
  "stack--p-space-1400": "web_ui__Stack__stack--p-space-1400",
  "stack--pt-space-1400": "web_ui__Stack__stack--pt-space-1400",
  "stack--pr-space-1400": "web_ui__Stack__stack--pr-space-1400",
  "stack--pb-space-1400": "web_ui__Stack__stack--pb-space-1400",
  "stack--pl-space-1400": "web_ui__Stack__stack--pl-space-1400",
  "stack--px-space-1400": "web_ui__Stack__stack--px-space-1400",
  "stack--py-space-1400": "web_ui__Stack__stack--py-space-1400",
  "stack--p-space-1600": "web_ui__Stack__stack--p-space-1600",
  "stack--pt-space-1600": "web_ui__Stack__stack--pt-space-1600",
  "stack--pr-space-1600": "web_ui__Stack__stack--pr-space-1600",
  "stack--pb-space-1600": "web_ui__Stack__stack--pb-space-1600",
  "stack--pl-space-1600": "web_ui__Stack__stack--pl-space-1600",
  "stack--px-space-1600": "web_ui__Stack__stack--px-space-1600",
  "stack--py-space-1600": "web_ui__Stack__stack--py-space-1600",
  "stack--p-space-2400": "web_ui__Stack__stack--p-space-2400",
  "stack--pt-space-2400": "web_ui__Stack__stack--pt-space-2400",
  "stack--pr-space-2400": "web_ui__Stack__stack--pr-space-2400",
  "stack--pb-space-2400": "web_ui__Stack__stack--pb-space-2400",
  "stack--pl-space-2400": "web_ui__Stack__stack--pl-space-2400",
  "stack--px-space-2400": "web_ui__Stack__stack--px-space-2400",
  "stack--py-space-2400": "web_ui__Stack__stack--py-space-2400",
  "stack--p-space-3200": "web_ui__Stack__stack--p-space-3200",
  "stack--pt-space-3200": "web_ui__Stack__stack--pt-space-3200",
  "stack--pr-space-3200": "web_ui__Stack__stack--pr-space-3200",
  "stack--pb-space-3200": "web_ui__Stack__stack--pb-space-3200",
  "stack--pl-space-3200": "web_ui__Stack__stack--pl-space-3200",
  "stack--px-space-3200": "web_ui__Stack__stack--px-space-3200",
  "stack--py-space-3200": "web_ui__Stack__stack--py-space-3200",
  "stack": "web_ui__Stack__stack",
  "width-parent": "web_ui__Stack__width-parent",
  "width-content": "web_ui__Stack__width-content",
  "width-custom": "web_ui__Stack__width-custom",
  "height-parent": "web_ui__Stack__height-parent",
  "height-content": "web_ui__Stack__height-content",
  "height-custom": "web_ui__Stack__height-custom",
  "scroll": "web_ui__Stack__scroll",
  "horizontal": "web_ui__Stack__horizontal",
  "fill-equally": "web_ui__Stack__fill-equally",
  "vertical": "web_ui__Stack__vertical",
  "wrap": "web_ui__Stack__wrap",
  "stack--gap-none": "web_ui__Stack__stack--gap-none",
  "stack--gap-x-small": "web_ui__Stack__stack--gap-x-small",
  "stack--gap-small": "web_ui__Stack__stack--gap-small",
  "stack--gap-regular": "web_ui__Stack__stack--gap-regular",
  "stack--gap-medium": "web_ui__Stack__stack--gap-medium",
  "stack--gap-large": "web_ui__Stack__stack--gap-large",
  "stack--gap-larger": "web_ui__Stack__stack--gap-larger",
  "stack--gap-x-large": "web_ui__Stack__stack--gap-x-large",
  "stack--gap-x-larger": "web_ui__Stack__stack--gap-x-larger",
  "stack--gap-x2-large": "web_ui__Stack__stack--gap-x2-large",
  "stack--gap-x3-large": "web_ui__Stack__stack--gap-x3-large",
  "stack--gap-x4-large": "web_ui__Stack__stack--gap-x4-large",
  "stack--gap-x5-large": "web_ui__Stack__stack--gap-x5-large",
  "stack--gap-x6-large": "web_ui__Stack__stack--gap-x6-large",
  "stack--gap-space-0": "web_ui__Stack__stack--gap-space-0",
  "stack--gap-space-50": "web_ui__Stack__stack--gap-space-50",
  "stack--gap-space-100": "web_ui__Stack__stack--gap-space-100",
  "stack--gap-space-150": "web_ui__Stack__stack--gap-space-150",
  "stack--gap-space-200": "web_ui__Stack__stack--gap-space-200",
  "stack--gap-space-300": "web_ui__Stack__stack--gap-space-300",
  "stack--gap-space-400": "web_ui__Stack__stack--gap-space-400",
  "stack--gap-space-500": "web_ui__Stack__stack--gap-space-500",
  "stack--gap-space-600": "web_ui__Stack__stack--gap-space-600",
  "stack--gap-space-700": "web_ui__Stack__stack--gap-space-700",
  "stack--gap-space-900": "web_ui__Stack__stack--gap-space-900",
  "stack--gap-space-800": "web_ui__Stack__stack--gap-space-800",
  "stack--gap-space-1000": "web_ui__Stack__stack--gap-space-1000",
  "stack--gap-space-1100": "web_ui__Stack__stack--gap-space-1100",
  "stack--gap-space-1200": "web_ui__Stack__stack--gap-space-1200",
  "stack--gap-space-1400": "web_ui__Stack__stack--gap-space-1400",
  "stack--gap-space-1600": "web_ui__Stack__stack--gap-space-1600",
  "stack--gap-space-2400": "web_ui__Stack__stack--gap-space-2400",
  "stack--gap-space-3200": "web_ui__Stack__stack--gap-space-3200",
  "stack--justify-center": "web_ui__Stack__stack--justify-center",
  "stack--justify-end": "web_ui__Stack__stack--justify-end",
  "stack--justify-start": "web_ui__Stack__stack--justify-start",
  "stack--justify-space-in-between": "web_ui__Stack__stack--justify-space-in-between",
  "stack--justify-space-around": "web_ui__Stack__stack--justify-space-around",
  "stack--justify-space-evenly": "web_ui__Stack__stack--justify-space-evenly",
  "stack--align-center": "web_ui__Stack__stack--align-center",
  "stack--align-top": "web_ui__Stack__stack--align-top",
  "stack--align-bottom": "web_ui__Stack__stack--align-bottom",
  "stack--align-baseline": "web_ui__Stack__stack--align-baseline"
};

var Stack = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    children = _ref.children,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 'parent' : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'parent' : _ref$width,
    scroll = _ref.scroll,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'row' : _ref$direction,
    _ref$distribution = _ref.distribution,
    distribution = _ref$distribution === void 0 ? 'start' : _ref$distribution,
    _ref$alignment = _ref.alignment,
    alignment = _ref$alignment === void 0 ? 'top' : _ref$alignment,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? 'none' : _ref$gap,
    _ref$wrap = _ref.wrap,
    wrap = _ref$wrap === void 0 ? false : _ref$wrap,
    _ref$fillEqually = _ref.fillEqually,
    fillEqually = _ref$fillEqually === void 0 ? false : _ref$fillEqually,
    padding = _ref.padding,
    paddingTop = _ref.paddingTop,
    paddingRight = _ref.paddingRight,
    paddingBottom = _ref.paddingBottom,
    paddingLeft = _ref.paddingLeft,
    paddingHorizontal = _ref.paddingHorizontal,
    paddingVertical = _ref.paddingVertical,
    testId = _ref.testId;
  var sizingClass = getSizingClassName(styles, width, height);
  var style = getSizingStyle('stack', width, height);
  var paddingClass = getPaddingClasses(styles, 'stack', {
    padding: padding,
    paddingTop: paddingTop,
    paddingRight: paddingRight,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    paddingX: paddingHorizontal,
    paddingY: paddingVertical
  });
  var stackClass = classNames(sizingClass, paddingClass, [styles["stack--justify-".concat(distribution)]], [styles["stack--align-".concat(alignment)]], [styles["stack--gap-".concat(gap)]], fillEqually && [[styles['fill-equally']]], wrap && [[styles.wrap]], scroll && [[styles.scroll]]);
  var finalClass = classNames(styles.stack, stackClass, _defineProperty(_defineProperty({}, styles.horizontal, direction === 'row'), styles.vertical, direction === 'column'));
  return /*#__PURE__*/jsx(Component, {
    className: finalClass,
    ref: ref,
    "data-testid": getTestId(testId, 'parent'),
    style: style,
    children: children
  });
});
Stack.displayName = 'Stack';

export { Stack as default };
//# sourceMappingURL=Stack.js.map
